import React from 'react'
import { SvgIcon } from './SvgIcon'

interface Props {
  className?: string
}

export function Settings({ className }: Props) {
  return (
    <SvgIcon className={className} viewBox="0 0 30 30" fill="currentColor">
      <path
        d="M16.66,0A1.38,1.38,0,0,1,18,1h0l.55,2.22a12.2,12.2,0,0,1,2.27.94h0l2-1.18a1.4,1.4,0,0,1,.71-.19,1.36,1.36,0,0,1,1,.4h0l2.35,2.35A1.36,1.36,0,0,1,27,7.24h0L25.81,9.19a12.2,12.2,0,0,1,.94,2.27h0L29,12a1.38,1.38,0,0,1,1,1.33h0v3.32A1.38,1.38,0,0,1,29,18h0l-2.22.55a12.2,12.2,0,0,1-.94,2.27h0l1.18,2a1.35,1.35,0,0,1-.21,1.66h0l-2.35,2.35a1.36,1.36,0,0,1-1,.4,1.4,1.4,0,0,1-.71-.19h0l-2-1.18a12.2,12.2,0,0,1-2.27.94h0L18,29a1.38,1.38,0,0,1-1.33,1H13.34A1.36,1.36,0,0,1,12,29h0l-.56-2.22a12.2,12.2,0,0,1-2.27-.94h0L7.24,27a1.4,1.4,0,0,1-.71.19,1.36,1.36,0,0,1-1-.4h0L3.22,24.43A1.36,1.36,0,0,1,3,22.77H3l1.18-2a12.2,12.2,0,0,1-.94-2.27h0L1,18a1.38,1.38,0,0,1-1-1.33H0V13.34A1.38,1.38,0,0,1,1,12H1l2.22-.55a12.2,12.2,0,0,1,.94-2.27h0L3,7.24a1.38,1.38,0,0,1,.21-1.67h0L5.57,3.22a1.36,1.36,0,0,1,1-.4A1.4,1.4,0,0,1,7.24,3h0L9.19,4.19a12.2,12.2,0,0,1,2.27-.94h0L12,1a1.36,1.36,0,0,1,1.32-1h3.32ZM15,8.18A6.82,6.82,0,1,0,21.82,15,6.83,6.83,0,0,0,15,8.18Z"
        fillRule="evenodd"
      />
    </SvgIcon>
  )
}
